<template>
  <div :class="classes">
      <pt-page-title title="促销管理">
          <template slot="before-left">
            <el-button type="primary" @click="createdCoupon">新建优惠劵</el-button>
            <el-button type="primary" @click="createdPromotion">新建促销活动</el-button>
            <el-button type="primary" @click="editNewcomer">编辑新人大礼包</el-button>
            <el-button type="primary" @click="newcomerDetail">新人大礼包详情</el-button>
          </template>
      </pt-page-title>
        <pt-page-menu-filter :tabs="typeTabs" v-model="selectTab" state="type"></pt-page-menu-filter>
        <pt-coupon-table ref="table" v-if="selectTab=='coupon'">
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.status=='WAITING_COMMIT'" @click="submitReview(scope.row)">提交审核</el-button>
                    <el-button type="text" @click="edit(scope.row)" :disabled="disableEdit(scope.row)">编辑</el-button>
                    <el-button type="text" @click="deleteCoupon(scope.row)" v-if="!(scope.row.status=='ACTIVATED'&&(new Date().getTime() < scope.row.couponData.startTime||(new Date().getTime() >= scope.row.couponData.startTime && new Date().getTime() <= scope.row.couponData.endTime)))">删除</el-button>
                    <!-- <el-button type="text" v-if="scope.row.status=='ACTIVATED'||scope.row.status=='NON_RECEIVABLE'" @click="couponDetail(scope.row)">查看</el-button> -->
                    <el-button type="text" :disabled="scope.row.status=='DISABLED'" @click="couponEnd(scope.row)" v-if="scope.row.status=='ACTIVATED'&&(new Date().getTime() < scope.row.couponData.startTime||(new Date().getTime() >= scope.row.couponData.startTime && new Date().getTime() <= scope.row.couponData.endTime))">停止</el-button>
                    <el-button type="text" @click="download(scope.row)" v-if="scope.row.grantType==='QR_CODE'&&scope.row.status=='ACTIVATED'&&(new Date().getTime() < scope.row.couponData.startTime||(new Date().getTime() >= scope.row.couponData.startTime && new Date().getTime() <= scope.row.couponData.endTime))">下载</el-button>
                    <el-button type="text" @click="couponDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </pt-coupon-table>
        <pt-promotion-table ref="promotionTable" v-else :labels="promotionTableLabels" :selectTab="selectTab">
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="editPromotion(scope.row)" :disabled="disableEditPromotion(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" @click="networkPromotion(scope.row)" v-if="scope.row.promotionData&&scope.row.promotionData.promotionType=='COUPONS_PACKAGE'">推广</el-button> -->
                    <el-button type="text" :disabled="scope.row.status=='DISABLED'" @click="promotionEnd(scope.row)" v-if="scope.row.status=='ACTIVATED'&&(new Date().getTime() < scope.row.promotionData.startTime||(new Date().getTime() >= scope.row.promotionData.startTime && new Date().getTime() <= scope.row.promotionData.endTime))">结束</el-button>
                    <el-button type="text" @click="deletePromotion(scope.row)" v-else>删除</el-button>
                    <el-button type="text" @click="promotionDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </pt-promotion-table>
        <!-- <div>
            <iframe src="http://test.man.daishuyifu.com/product-cord" width="100%" height="500px;"  frameborder="0" name="fff"></iframe>
        </div> -->
        <el-dialog :title="dialog_title" :visible="is_dialog" :class="$style['down-dialog']" @close="closeDialog">
            <coupon-download v-if="is_download" :coupon-massage="coupon_massage" :type="qr_code_type"></coupon-download>
        </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { typeTabs, promotionTableLabels } from './promotion-option.js'
import ptCouponTable from './pt-coupon-table/withData'
import ptPromotionTable from './pt-promotion-table/withData'
import couponDownload from './coupon-download'
const prefixCls = 'pt-promotion-coupon'
export default {
  name: 'pt-promotion-coupon',
  data () {
    return {
      typeTabs: typeTabs,
      selectTab: '',
      queryParams: {},
      dialog_title: '',
      is_download: false,
      coupon_massage: {},
      promotionTableLabels: promotionTableLabels,
      qr_code_type: 'conpon'
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_download
      },
      set: function (val) {
        this.is_download = val
      }
    }
  },
  components: {
    ptCouponTable,
    couponDownload,
    ptPromotionTable
  },
  methods: {
    // 优惠券编辑是否可用
    disableEdit (row) {
      return row.status === 'ACTIVATED' || row.status === 'DISABLED' || row.status === 'NON_RECEIVABLE'
    },
    // 促销活动编辑是否不可用
    disableEditPromotion (row) {
      return row.id !== 'newcomer' && ((row.status === 'ACTIVATED' && row.promotionData && row.promotionData.promotionType !== 'CASH_BACK') || row.status === 'DISABLED' || row.status === 'NON_RECEIVABLE')
    },
    couponDetail (val) {
      this.$router.push('/promotion-coupon/coupon-detail/' + val.id)
    },
    promotionDetail (val) {
      this.$router.push('/promotion-coupon/propmotion-detail/' + val.id)
    },
    deletePromotion (val) {
      this.$confirm('您确定删除该促销活动吗', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('promotionDelete', val.id)
      })
    },
    networkPromotion (val) {
      this.is_download = true
      this.dialog_title = '推广活动'
      this.coupon_massage = val
      this.qr_code_type = 'promotion'
    },
    editPromotion (val) {
      let rowIsActive = val.promotionData && val.promotionData.promotionType === 'CASH_BACK' && val.status === 'ACTIVATED'
      this.$router.push('/promotion-coupon/promotion-form/true/' + val.id + '/' + rowIsActive)
    },
    editNewcomer () {
      this.$router.push('/promotion-coupon/promotion-form/true/newcomer')
    },
    newcomerDetail () {
      this.$router.push('/promotion-coupon/propmotion-detail/newcomer')
    },
    closeDialog () {
      this.is_download = false
    },
    download (val) {
      this.is_download = true
      this.dialog_title = '下载优惠劵'
      this.coupon_massage = val
    },
    submitReview (val) {
      this.$confirm('您确定对该优惠劵提交审核吗', '提交审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('couponStatus', val.id, 'WAITING_AUDIT')
      })
    },
    deleteCoupon (val) {
      this.$confirm('您确定删除该优惠劵吗', '删除优惠劵', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('deleteCoupon', val.id)
      })
    },
    couponList () {
      let page = this.$refs.table.page
      this.$refs.table.couponList(page)
    },
    promotionsList () {
      let page = this.$refs.promotionTable.page
      this.$refs.promotionTable.promotionList(page)
    },
    edit (val) {
      this.$router.push('/promotion-coupon/coupon-form/true/' + val.id)
    },
    createdCoupon () {
      this.$router.push('/promotion-coupon/coupon-form/false/0')
    },
    createdPromotion () {
      this.$router.push('/promotion-coupon/promotion-form/false/0')
    },
    promotionEnd (val) {
      this.$confirm('您确定结束该促销活动吗', '结束优惠劵', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('promotionStatus', val.id, 'DISABLED')
      })
    },
    couponEnd (val) {
      this.$confirm('您确定结束该优惠劵的使用吗', '结束优惠劵', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('couponStatus', val.id, 'NON_RECEIVABLE')
      })
    }
  },
  created () {
    this.selectTab = this.$route.query.type
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.down-dialog{
    :global
    .el-dialog{
        width: 40%;
        max-width: 550px;
        .el-dialog__body{
            padding: 20px;
        }
    }
}
</style>
